module.exports = __webpack_public_path__ + "static/media/skill3_neg_en.1b84bd46.txt";